import { motion } from 'framer-motion';

export default function Progress({
    text,
    percentage,
}: {
    text: string;
    percentage: number;
}) {
    percentage = percentage ?? 0;
    const isComplete = percentage >= 100;
    const isNearComplete = percentage >= 90;

    return (
        <div className='mt-0.5 w-full relative text-sm bg-gray-100 dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-sm'>
            <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${percentage}%` }}
                transition={{ 
                    duration: 0.3,
                    ease: "easeOut"
                }}
                className={`
                    top-0 h-full whitespace-nowrap px-2 py-1
                    ${isComplete 
                        ? 'bg-green-500 dark:bg-green-600' 
                        : isNearComplete
                            ? 'bg-blue-600 dark:bg-blue-700'
                            : 'bg-blue-500 dark:bg-blue-600'
                    }
                    transition-colors duration-300
                `}
            >
                <div className="flex items-center gap-2">
                    <span className="text-white font-medium truncate">
                        {text}
                    </span>
                    <span className="text-white/90 text-xs">
                        {`${Math.min(100, Math.max(0, percentage)).toFixed(1)}%`}
                    </span>
                    {isNearComplete && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.2 }}
                            className="ml-1 flex-shrink-0"
                        >
                            <div className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                            </div>
                        </motion.div>
                    )}
                </div>
            </motion.div>
        </div>
    );
}
